import { handleAction } from 'redux-actions';
import { RUTAS } from '../actions';

const basename = '/pagos';
const stateDefault = {
    login       : basename + '/login',
    producto    : basename + '/producto',
    declarante  : basename + '/declarante',
    siniestro   : basename + '/siniestro',
    suscripcion   : basename + '/suscripcion',
    blankpage   : basename + '/blankpage',
    activoAgregar   : basename + '/activo/agregar',
    activoResumen   : basename + '/activo/resumen',
    cuentaAbono     : basename + '/cuentaabono',
    fotossiniestro  : basename + '/agregafotossiniestro',
    fotosfactura    : basename + '/agregafotosfactura',
    gracias         : basename + '/gracias',
};

export default handleAction(   
    RUTAS, (state) => Object.assign({}, state), stateDefault
);
